'use strict';

module.exports = function(calendarSettings) {
  return {
    pixelToTime: pixelToTime,
    timeToPixel: timeToPixel,
    minutesToPixel: minutesToPixel,
  };

  /**
   * get hours and minutes from pixel
   * @param {number} pixel
   * @param {boolean} useOffset
   * @returns {{hours: number, minutes: number}}
   */
  function pixelToTime(pixel, useOffset) {
    var offset = useOffset ? calendarSettings.offset : 0;
    var hours = Math.floor(pixel / calendarSettings.hourHeight) + offset;
    var minutes = Math.floor(
      ((pixel % calendarSettings.hourHeight) / calendarSettings.hourHeight) * 60,
    );
    var roundedMinutes = 15 * Math.round(minutes / 15);

    if (roundedMinutes === 60) {
      hours++;
      roundedMinutes = 0;
    }

    return {
      hours: hours,
      minutes: minutes,
      roundedMinutes: roundedMinutes,
    };
  }

  /**
   * get pixel (top) from datetime
   * @param {date} dateTime
   * @returns {number}
   */
  function timeToPixel(dateTime) {
    var hours = dateTime.getHours();
    var minutes = dateTime.getMinutes();

    return Math.floor(
      (hours + minutes / 60 - calendarSettings.offset) * calendarSettings.hourHeight,
    );
  }

  /**
   * mainly used for calc absent time blocks
   * @param {number} minutes
   * @returns {number}
   */
  function minutesToPixel(minutes, disableOffset) {
    var offset = disableOffset ? 0 : calendarSettings.offset;

    return Math.floor((minutes / 60 - offset) * calendarSettings.hourHeight);
  }
};



// WEBPACK FOOTER //
// ./src/app/modules/calendar/PixelTimeCalcServce.js